<template>
  <div id="modal-profile" ref="profileModal" class="uk-modal-full user-profile-modal" uk-modal
       @click="handleModalClick">
    <div class="uk-modal-footer uk-text-right bggray">
      <button class="uk-button uk-button-default small" type="button" @click="handleCloseClick"><i
          class="uil-times"></i>
        {{ $t("general.close") }}
      </button>
    </div>
    <div v-if="userData" class="uk-modal-dialog bggray">

      <div class="uk-padding-large position-relative"
           style="background-color:#edeff0 !important; display: flex; flex-wrap: nowrap; gap: 15px;">
        <div class="first-col" style="width: 20%; flex-shrink: 0;">
          <UserProfileCard :user-data="userData"
                           @openMessageModal="openMessageModal"
                           @showAddCertificate="showAddCertificateModal = true"
                           @showUserCompetencies="showUserCompetenciesModal = true"/>

          <ProfileLevel v-if="hasUserDetail"
                        :certificates-count="certificatesCount"
                        :user-coin="userCoin"
                        :user-point="userPoint"/>
          <div v-else class="section-loading level-loading">
            <default-loading min-height="140px"></default-loading>
          </div>

        </div>
        <div class="second-col" style="width: 30%; flex-shrink: 0;">
          <UserStatistics v-if="hasUserDetail"
                          :gifts-count="giftsCount"
                          :user-coin="userCoin"
                          :user-item="userItem"
                          :user-point="userPoint"/>
          <div v-else class="section-loading statistics-loading">
            <default-loading min-height="140px"></default-loading>
          </div>

          <UserPersonalInfo :user-data="userData"
                            :user_detail="user_detail"
                            :hide-email="shouldHideEmailField"
                            @closeModal="closeModal"/>

          <CompanyInformations v-if="hasUserDetail"
                               :user-item="userItem"
                               :user_detail="user_detail"
                               @closeModal="closeModal"/>
          <div v-else class="section-loading company-loading">
            <default-loading min-height="140px"></default-loading>
          </div>

          <UserCollections v-if="hasUserDetail"
                           :collections="collections"
                           :user-data="userData"/>
          <div v-else class="section-loading collections-loading">
            <default-loading min-height="140px"></default-loading>
          </div>

        </div>
        <div class="third-col" style="width: 50%; flex-shrink: 0;">
          <div v-if="assignmentsLoading" class="section-loading assignments-loading">
            <default-loading min-height="360px"></default-loading>
          </div>
          <AssignmentsTable v-else
                            :assignments="assignments"
                            :assignments-pagination="assignmentsPagination"
                            @changePage="handleAssignmentPageChange"
                            @openContentCompleteModal="openContentCompleteModal"/>
        </div>
      </div>
    </div>


    <SendMessage v-if="sendMessageToUserId"
                 :user-id="sendMessageToUserId"
                 @close="handleSendMessageClose"/>

    <!-- Add Certificate Modal -->
    <AppModal :bottom-sheet="true"
              :title="$t('certificate.add')"
              :visible.sync="showAddCertificateModal"
              max-height="90vh"
              width="800px"
              @close="showAddCertificateModal = false">
      <AddCertificateModal v-if="showAddCertificateModal"
                           ref="addCertModal"
                           :loading="modalLoading"
                           @submit="handleCertificateSubmit"/>
      <template #footer>
        <button class="btn btn-outline-secondary" type="button" @click="showAddCertificateModal = false">
          {{ $t('general.cancel') }}
        </button>
        <button :disabled="modalLoading" class="cert-add-btn" type="button"
                @click="$refs.addCertModal && $refs.addCertModal.onSubmit()">
          {{ $t('general.save') }}
        </button>
      </template>
    </AppModal>

    <!-- User Competencies Modal -->
    <UserCompetenciesModal :user-id="userData?.id"
                           :user-name="`${userData?.name} ${userData?.surname}`"
                           :visible="showUserCompetenciesModal"
                           @close="closeUserCompetenciesModal"/>

    <!-- Complete Assignment Modal -->
    <CompleteAssignmentModal v-if="showCompleteModal && selectedAssignmentContents.length"
                             :contents="selectedAssignmentContents"
                             @close="closeCompleteModal"
                             @contents-selected="setContentsToSelected"/>
  </div>
</template>
<script>

import moment from "moment";

import SendMessage from "@/view/company/User/SendMessage.vue";
import AddCertificateModal from '@/view/components/modal/AddCertificateModal.vue';
import AppModal from "@/view/components/ui/AppModal.vue";
import { showAlert, showError, showSuccess } from '@/utils/alertUtils.js';
import CompleteAssignmentModal from "@/view/components/modal/CompleteAssignmentModal.vue";
import UserCompetenciesModal from "@/view/company/User/components/UserCompetenciesModal.vue";
import Pagination from "@/assets/components/Pagination.vue";
import { formatDate, timeSecondConvert } from '@/utils/timeUtils.js';

import UserProfileCard from "@/view/company/User/components/UserProfileCard.vue";
import ProfileLevel from "@/view/company/User/components/ProfileLevel.vue";
import UserStatistics from "@/view/company/User/components/UserStatistics.vue";
import UserPersonalInfo from "@/view/company/User/components/UserPersonalInfo.vue";
import CompanyInformations from "@/view/company/User/components/CompanyInformations.vue";
import UserCollections from "@/view/company/User/components/UserCollections.vue";
import AssignmentsTable from "@/view/company/User/components/AssignmentsTable.vue";
import DefaultLoading from "@/view/components/loading/DefaultLoading.vue";

import ApiService from "@/core/services/api.service";

export default {
  name: "UserProfile",
  components: {
    SendMessage,
    AddCertificateModal,
    AppModal,
    CompleteAssignmentModal,
    UserCompetenciesModal,
    Pagination,
    UserProfileCard,
    ProfileLevel,
    UserStatistics,
    UserPersonalInfo,
    CompanyInformations,
    UserCollections,
    AssignmentsTable,
    DefaultLoading
  },
  data() {
    return {
      modalInstance: null,
      sendMessageToUserId: null,
      showAddCertificateModal: false,
      modalLoading: false,
      showCompleteModal: false,
      selectedAssignmentContents: [],
      selectedAssignmentId: null,
      showUserCompetenciesModal: false
    };
  },
  props: {
    item: {
      default: null,
      type: Object,
    },
    user_detail: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
      type: Boolean,
    },
  },
  computed: {
    hasUserDetail() {
      return !!this.user_detail;
    },
    shouldHideEmailField() {
      const companyId = this.userData?.company_id
        || this.userData?.company?.id
        || this.user_detail?.user?.company_id
        || this.user_detail?.user?.company?.id;

      return Number(companyId) === 489;
    },
    assignmentsLoading() {
      return this.loading || !this.hasUserDetail;
    },

    userData() {
      // Önce item'dan veriyi al, eğer item minimal ise (sadece id) user_detail'den tamamla
      let userData = this.item;

      // Eğer item minimal veri içeriyorsa (URL'den direkt açıldıysa) user_detail.user'ı kullan
      if (userData && Object.keys(userData).length <= 2 && this.user_detail?.user) {
        userData = { ...this.user_detail.user, id: userData.id };
      }

      if (userData && userData.hasOwnProperty('dob') && userData.dob) {
        userData.dob = userData.dob && userData.dob != "-" ? moment(userData.dob).format('DD/MM/YYYY') : '-';
      }
      return userData;
    },
    userItem() {
      return this.user_detail && typeof this.user_detail.user !== "undefined" ? this.user_detail.user : {};
    },
    assignments() {
      const assignmentItems = Array.isArray(this.user_detail?.assignments?.data)
        ? this.user_detail.assignments.data
        : Array.isArray(this.user_detail?.assignments)
          ? this.user_detail.assignments
          : [];

      return assignmentItems
        .filter(item => item && typeof item === "object")
        .map(item => ({
          ...item,
          id: item.id || item.assignment_id || item.assignment_user_id,
          name: item.name
            || item.title
            || item.assignment_name
            || item.content_name
            || item.program_name
            || item.assignment?.name
            || item.content?.name
            || item.program?.name
            || '-'
        }))
        .filter(item => item.id);
    },

    collections() {
      if (!Array.isArray(this.user_detail?.collections)) {
        return [];
      }

      return this.user_detail.collections.filter(collection => collection && typeof collection === 'object');
    },
    userPoint() {
      return this.user_detail && typeof this.user_detail.user_point !== "undefined" ? Number(this.user_detail.user_point) : 0;
    },
    userCoin() {
      return this.user_detail && typeof this.user_detail.user_coin !== "undefined" ? Number(this.user_detail.user_coin) : 0;
    },
    giftsCount() {
      return this.user_detail && typeof this.user_detail.gifts_count !== "undefined" ? Number(this.user_detail.gifts_count) : 0;
    },
    certificatesCount() {
      return this.user_detail && typeof this.user_detail.user?.certificatables_count !== "undefined" ? Number(this.user_detail.user?.certificatables_count) : 0;
    },
    assignmentsPagination() {
      // Paginated yapıdan pagination bilgilerini al
      if (this.user_detail?.assignments && typeof this.user_detail.assignments === 'object' && this.user_detail.assignments.data) {
        return {
          current_page: this.user_detail.assignments.current_page || 1,
          last_page: this.user_detail.assignments.last_page || 1,
          per_page: this.user_detail.assignments.per_page || 15,
          total: this.user_detail.assignments.total || 0,
          from: this.user_detail.assignments.from || 0,
          to: this.user_detail.assignments.to || 0
        };
      }
      return null;
    }
  },
  methods: {
    formatDate,
    timeSecondConvert,
    async openContentCompleteModal(assignment) {
      try {
        // API'den assignment detaylarını çek
        const response = await ApiService.get(`api/user/detail-admin/${this.userData.id}/assignment/${assignment.id}`);

        if (response && response.data) {
          // Assignment ID'sini sakla
          this.selectedAssignmentId = assignment.id;

          const contentsPrograms = response.data.contents_programs || [];

          const processedData = contentsPrograms.map(item => {
            if (item.is_program && item.sections) {
              // Program ise, type ekle
              return {
                ...item,
                type: 'program',
                name: item.title,
                cover_photo_link: item.cover,
                sections: item.sections.map(section => ({
                  ...section,
                  contents: section.contents.map(content => ({
                    ...content,
                    type: 'content',
                    name: content.title,
                    cover_photo_link: content.cover
                  }))
                }))
              };
            } else {
              // Normal content ise type ekle
              return {
                ...item,
                type: 'content',
                name: item.title,
                cover_photo_link: item.cover
              };
            }
          });

          this.selectedAssignmentContents = processedData;
          this.showCompleteModal = true;

          if (!this.selectedAssignmentContents.length) {
            showAlert(this.$t('general.selected_training_content_empty'));
          }
        }
      } catch (error) {
        console.error('Assignment detayları alınamadı:', error);
        showError(this.$t('general.training_details_load_error'));
      }
    },
    openMessageModal() {
      this.sendMessageToUserId = this.userData.id;
    },
    handleSendMessageClose() {
      this.sendMessageToUserId = null;
    },
    closeModal() {
      const modal = UIkit.modal("#modal-profile");
      if (modal) modal.$destroy(true);
      this.$router.push({ name: 'company.user.edit', params: { id: this.userData.id } })
    },
    closeCompleteModal() {
      this.showCompleteModal = false;
      this.selectedAssignmentContents = [];
    },

    setContentsToSelected(selectedContents) {
      // Seçili content ID'lerini al
      const selectedIds = selectedContents.map(content => content.id);
      const contents = [];
      const processedPrograms = new Set();

      // Orijinal veriyi kullanarak programa göre grupla
      this.selectedAssignmentContents.forEach(item => {
        if (item.type === 'program' && item.sections) {
          // Tüm section'lardaki seçili content'leri topla (flatten)
          const allChildren = [];

          item.sections.forEach(section => {
            const selectedChildren = section.contents
                .filter(c => selectedIds.includes(c.id))
                .map(c => c.id);

            allChildren.push(...selectedChildren);
          });

          if (allChildren.length > 0 && !processedPrograms.has(item.id)) {
            // Program olarak ekle (children ile birlikte - sections olmadan)
            contents.push({
              type: 'program',
              id: item.id,
              children: allChildren
            });
            processedPrograms.add(item.id);
          }
        } else {
          // Standalone content
          if (selectedIds.includes(item.id)) {
            contents.push({
              type: 'content',
              id: item.id
            });
          }
        }
      });

      const data = {
        user_id: this.userData.id,
        assignment_id: this.selectedAssignmentId,
        contents: contents
      };

      ApiService.post('api/assignment/complete-content-manuel', data)
          .then(response => {
            if (response.status) {
              showSuccess(this.$t('general.training_marked_completed'));
              this.$emit('refresh', this.userData.id);
            }
            this.closeCompleteModal();
          }).catch(error => {
        showError(this.$t('general.operation_error'));
      });
    },
    handleModalClick(event) {
      // Eğer child modal açıksa, UserProfile modal'ının kapanmasını engelle
      if (this.showCompleteModal || this.showAddCertificateModal || this.showUserCompetenciesModal) {
        event.stopPropagation();
      }
    },

    async handleCertificateSubmit(formData) {
      this.modalLoading = true;
      try {
        formData.append('user_id', this.userData.id);

        await ApiService.post('/api/user-certificate', formData);
        this.showAddCertificateModal = false;
        this.$emit('refresh', this.userData.id);
        showSuccess(this.$t('general.certificate_added_successfully'));
      } catch (e) {
        showError(this.$t('general.certificate_add_error'));
      } finally {
        this.modalLoading = false;
      }
    },

    closeUserCompetenciesModal() {
      this.showUserCompetenciesModal = false;
    },
    handleCloseClick(event) {
      event.preventDefault();

      if (this.modalInstance) {
        this.modalInstance.hide();
      }
    },
    handleModalHidden() {
      this.$emit('modalClosed');
    },
    handleAssignmentPageChange(page) {
      // Parent component'e sayfa değişikliğini bildir
      this.$emit('assignmentPageChanged', page);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.modalInstance = UIkit.modal(this.$refs.profileModal);

      if (this.$refs.profileModal) {
        UIkit.util.on(this.$refs.profileModal, 'hidden', this.handleModalHidden);
      }

      if (this.modalInstance) {
        this.modalInstance.show();
      }
    });
  },
  beforeDestroy() {
    if (this.$refs.profileModal) {
      UIkit.util.off(this.$refs.profileModal, 'hidden', this.handleModalHidden);
    }

    if (this.modalInstance) {
      this.modalInstance.$destroy(true);
      this.modalInstance = null;
    }
  },
};
</script>

<style scoped>
.user-profile-modal .uk-modal-dialog {
  height: 100%;
}

.section-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 140px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.level-loading,
.company-loading,
.collections-loading {
  margin-top: 12px;
}

.statistics-loading {
  margin-bottom: 1.5rem;
}

.assignments-loading {
  min-height: 360px;
}

/* Özel bildirim stili */
:deep(.custom-notification) {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 12px 20px;
  border-left: 4px solid;
}

:deep(.custom-notification.success) {
  border-left-color: #28a745;
}

:deep(.custom-notification.danger) {
  border-left-color: #dc3545;
}

:deep(.notification-content) {
  display: flex;
  align-items: center;
  font-size: 14px;
}

:deep(.notification-content i) {
  font-size: 18px;
}

:deep(.custom-notification.success .notification-content i) {
  color: #28a745;
}

:deep(.custom-notification.danger .notification-content i) {
  color: #dc3545;
}

@media (max-width: 960px) {
  .user-profile-modal .uk-modal-footer {
    padding: 12px 16px;
  }

  .user-profile-modal .uk-modal-footer .uk-button {
    width: 100%;
    min-height: 48px;
    font-size: 16px;
  }

  .user-profile-modal .uk-padding-large {
    padding: 16px !important;
  }

  .user-profile-modal .uk-card-default {
    margin-top: 16px !important;
  }

  .user-profile-modal .section-header {
    margin-bottom: 16px !important;
  }

  .user-profile-modal h4,
  .user-profile-modal h5,
  .user-profile-modal p,
  .user-profile-modal span,
  .user-profile-modal a,
  .user-profile-modal button {
    word-break: break-word;
  }

  .user-profile-modal .course-card-body p {
    font-size: 14px;
  }

  .user-profile-modal .btn,
  .user-profile-modal .btn-block {
    min-height: 48px;
    font-size: 16px;
  }

  .user-profile-modal .btn-icon-only {
    min-width: 44px;
    min-height: 44px;
  }
}

.cert-add-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 44px;
  padding: 0 20px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  background: #2c3e50;
  border: 2px solid #2c3e50;
  border-radius: 10px;
  cursor: pointer;
  outline: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
}

.cert-add-btn:hover,
.cert-add-btn:focus,
.cert-add-btn:active {
  background: #1a2a3a;
  border-color: #1a2a3a;
  color: #fff;
  outline: none;
  box-shadow: none;
  transform: scale(0.98);
  opacity: 0.85;
}
</style>
